// extracted by mini-css-extract-plugin
module.exports = {"item":"Item_item__3DN-D"};